import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/browser';
import { AuthService } from './app/core/services/auth.service';
import { AppComponent } from './app/app.component';
import { APP_CONFIG } from './app/app.config';
import { LandingComponent } from './app/landing/landing.component';
import { LANDING_CONFIG } from './app/landing/landing.config';

enableProdMode();

if (!window.location.href.includes('landing')) {
	if (window.location.href.includes('/frame/')) {
		const params = new URLSearchParams(window.location.search);
		const token: string = params.get('token');
		const refreshToken: string = params.get('refreshToken');
		if (token) {
			localStorage.setItem('datawiz_auth_access_token', token);
			localStorage.setItem('datawiz_auth_refresh_token', refreshToken);
		}
	}

	AuthService.auth().then(() => {
		bootstrapApplication(AppComponent, APP_CONFIG)
			.catch((err) => console.error(err));
	});
} else {
	bootstrapApplication(LandingComponent, LANDING_CONFIG)
		.catch((err) => console.error(err));
}
